

const initialState = {
    countries: [],
    userId: 0,
    cacNumber: "",
    pass:'',
    pwd:'',
    orderId: "",
    locations:[],
    companyId:0,
    companyName:"",
    productCategories:[],
    credit:{},
    roles: "",
    users:[],
    userDrop:[],
    products:[],
    items:[]
};


function PersistReducer(state = initialState, action) {
    

    if (action.type === "PERSIST_COUNTRIES") {
        var productDetails = {
            ...state,
            countries: action.payload
        };
        return productDetails;
    }


    if (action.type === "PERSIST_ITEMS") {
        var productDetails = {
            ...state,
            items: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_EMAIL") {
        var productDetails = {
            ...state,
            pass: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_PASS") {
        var productDetails = {
            ...state,
            pwd: action.payload
        };
        return productDetails;
    }




    if (action.type === "PERSIST_CREDIT") {
        var productDetails = {
            ...state,
            credit: action.payload
        };
        return productDetails;
    }
    if (action.type === "PERSIST_USERS") {
        var productDetails = {
            ...state,
            users: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_USER_DROP") {
        var productDetails = {
            ...state,
            userDrop: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_PRODUCT_CATEGORY") {
        var productDetails = {
            ...state,
            productCategories: action.payload
        };
        return productDetails;
    }
    if (action.type === "PERSIST_ORDER_ID") {
        var productDetails = {
            ...state,
            orderId: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_ROLES") {
        var productDetails = {
            ...state,
            roles: action.payload
        };
        return productDetails;
    }


    if (action.type === "PERSIST_USER_ID") {
        var productDetails = {
            ...state,
            userId: action.payload
        };
        return productDetails;
    }



    if (action.type === "PERSIST_COMPANY_ID") {
        var productDetails = {
            ...state,
            companyId: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_LOCATIONS") {
        var productDetails = {
            ...state,
            locations: action.payload
        };
        return productDetails;
    }


    if (action.type === "PERSIST_COMPANY_NAME") {
        var productDetails = {
            ...state,
            companyName: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_CAC_NUMBER") {
        var productDetails = {
            ...state,
            cacNumber: action.payload
        };
        return productDetails;
    }

    if (action.type === "PERSIST_PRODUCTS") {
        var productDetails = {
            ...state,
            products: action.payload
        };
        return productDetails;
    }
    return state;
}

export default PersistReducer;














